<script setup>
import SelectInput from "@/Components/SelectInput.vue";
import InputLabel from "@/Components/InputLabel.vue";
import {onMounted, ref, watch} from "vue";

import {
    loadCompanies,
    getStoredCompany,
    setStoredCompany,
    loadSpecialities,
    getStoredSpeciality,
    setStoredSpeciality,
    loadEduForms,
    getStoredEduForm,
    setStoredEduForm,
    loadFinanceLevels,
    getStoredFinanceLevel,
    setStoredFinanceLevel,
    loadConcursGroups,
    getStoredSorting,
    clearStorage,
} from './competitionListUtils';
import Loader from "@/Components/Loader.vue";
import {Table, TBody, TR, TH, TD, THead} from "@/Components/Table";
import ConcursGroupItem
    from "@/Pages/Education/ReceptionCompany/CompetitionLists/components/CompetitionListV2/ConcursGroupItem.vue";
import Button from "@/Components/Button.vue";
import SortMenu from "@/Pages/Education/ReceptionCompany/CompetitionLists/components/SortMenu.vue";

const receptionCompanies = ref([]);
const receptionCompany = ref(null);

const specialities = ref([]);
const speciality = ref(null);

const eduForms = ref([]);
const eduForm = ref(null);

const financeLevels = ref([]);
const financeLevel = ref(null);

const isPay = ref(false);

const loadingConcursGroups = ref(false);
const concursGroups = ref([]);

async function loadDataFromStorage() {
    const savedCompany = getStoredCompany();
    if(savedCompany !== undefined && savedCompany !== null && receptionCompanies.value.filter(el => Number(el.id) === Number(savedCompany)).length > 0) {
        receptionCompany.value  = savedCompany;
        speciality.value        = getStoredSpeciality();
        eduForm.value           = getStoredEduForm();
        financeLevel.value      = getStoredFinanceLevel();
    }

    else {
        receptionCompany.value  = null;
        speciality.value        = null;
        eduForm.value           = null;
        financeLevel.value      = null;
        clearStorage();
    }
}

async function updateList() {
    sortType.value = getStoredSorting();
    loadingConcursGroups.value = true;
    concursGroups.value = [];
    if(!!receptionCompany.value && !!speciality.value && !!eduForm.value && !!financeLevel.value) {
        concursGroups.value = await loadConcursGroups(
            receptionCompany.value,
            speciality.value,
            eduForm.value,
            financeLevel.value
        );
    }
    loadingConcursGroups.value = false;
}

onMounted(async () => {
    receptionCompanies.value = await loadCompanies();
    loadDataFromStorage();
});

watch(receptionCompany, async (nv) => {
  if(nv !== getStoredCompany()) {
    setStoredCompany(nv);
    speciality.value = null;
    eduForm.value = null;
    financeLevel.value = null;
  }


  if(nv) {
      rcType.value = receptionCompanies.value.find(e => Number(e.id) === Number(nv)).type;
    loadSpecialities(nv).then((list) => { specialities.value = list; });
    loadEduForms().then((list) => { eduForms.value = list; });
    loadFinanceLevels().then((list) => { financeLevels.value = list; });
  }
});

watch(speciality, setStoredSpeciality);
watch(eduForm, setStoredEduForm);
watch(financeLevel, setStoredFinanceLevel);

watch(() => `${speciality.value}-${eduForm.value}-${financeLevel.value}`, updateList);

watch(() => `${financeLevel.value}-${financeLevels.value?.length}-${loadingConcursGroups.value}`, () => {
    let fl = financeLevels.value.find((e) => Number(e.id) === Number(financeLevel.value));
    isPay.value = fl?.guid === 'af4b0b25-c722-11ee-80f5-00155d01193e';
});

const sortType = ref(getStoredSorting());
const rcType = ref(null);
</script>

<template>
<div class="min-w-full p-5">
  <div class="w-full mb-2">
    <InputLabel for="receptionCompany" value="Приёмная кампания" />

    <SelectInput
        id="receptionCompany"
        :items="[{label: 'Выберите приёмную кампанию', value: null, disabled: true}].concat(receptionCompanies.map((el) => { return {label: el.display_name ? el.display_name : el.name, value: el.id}; }))"
        v-model="receptionCompany"
        class="mt-1 block w-full"
        placeholder="Приёмная кампания"
        autocomplete="receptionCompany"
    />
  </div>

  <div v-if="receptionCompany" class="flex space-x-2">
    <div class="w-full">
      <InputLabel for="speciality" value="Специальность" />

      <SelectInput
          id="speciality"
          :items="[{label: 'Выберите специальность', value: null, disabled: true}].concat(specialities.map((el) => { return {label: el.code + ' ' + el.name, value: el.id}; }))"
          v-model="speciality"
          class="mt-1 block w-full"
          placeholder="Специальность"
          autocomplete="speciality"
      />
    </div>

    <div class="w-full">
      <InputLabel for="eduForm" value="Форма обучения" />

      <SelectInput
          id="eduForm"
          :items="[{label: 'Выберите форму обучения', value: null, disabled: true}].concat(eduForms.map((el) => { return {label: el.name, value: el.id}; }))"
          v-model="eduForm"
          class="mt-1 block w-full"
          placeholder="Форма обучения"
          autocomplete="eduForm"
          :disabled="speciality === null"
      />
    </div>

    <div class="w-full">
      <InputLabel for="financeLevel" value="Уровень финансирования" />

      <SelectInput
          id="financeLevel"
          :items="[{label: 'Выберите уровень финансирования', value: null, disabled: true}].concat(financeLevels.map((el) => { return {label: el.display_name, value: el.id}; }))"
          v-model="financeLevel"
          class="mt-1 block w-full"
          placeholder="Уровень финансирования"
          autocomplete="financeLevel"
          :disabled="eduForm === null"
      />
    </div>
  </div>

    <div class="mt-4 space-x-1 flex flex-row">
        <SortMenu v-model="sortType" :is-pay="isPay" :rc-type="rcType"/>
        <Button class="b-primary" @click="updateList">
            <i class="fas fa-rotate mr-2"/> Обновить список
        </Button>
    </div>

  <div v-if="loadingConcursGroups" class="mt-4 flex flex-col items-center">
    <Loader/>
  </div>

  <div v-else class="mt-4 flex flex-col">
    <Table>
      <thead class="border">
        <tr class="border bg-gray-100">
          <TH class="border !font-bold" colspan="7">Основание</TH>
          <TH class="border !font-bold" colspan="5">Конкурсная группа</TH>
          <TH class="border !font-bold text-center">Мест</TH>
        </tr>
      </thead>

      <TBody>
        <TR v-if="!concursGroups.length" class="border">
          <TD class="border text-center" colspan="11">Нет данных</TD>
        </TR>

        <template v-else>
            <ConcursGroupItem
                v-for="concursGroupDataItem in concursGroups"
                :key="concursGroupDataItem.concurs_group.id"
                :data="concursGroupDataItem"
                :sort-type="sortType"
            />
        </template>
      </TBody>
    </Table>
  </div>
</div>
</template>

<style scoped>

</style>
